import React from 'react';
import styled from 'styled-components';
import { Flex, Box, Text } from 'rebass/styled-components';

const HowItWorksSection = styled.section`
  max-width: 1300px;
  margin: 0px auto 80px auto;
  padding: 0 20px;
  font-family: 'Sk-Modernist-Regular', sans-serif;
  color: #252422;
`;

const SectionBadge = styled(Flex)`
  align-items: center;
  gap: 8px;
  margin-bottom: 20px;
`;

const BadgeText = styled(Text)`
  color: #ff4f00;
  font-weight: 500;
  font-size: 16px;
  line-height: 28px;
`;

const MainHeading = styled.h2`
  color: #ff4f00;
  font-weight: 400;
  line-height: 1.2;
  margin-bottom: 60px;

  font-size: 48px;

  @media (max-width: 1024px) {
    font-size: 40px;
  }

  @media (max-width: 768px) {
    font-size: 32px;
    margin-bottom: 40px;
  }

  @media (max-width: 480px) {
    font-size: 26px;
  }
`;

const StepsGrid = styled(Flex)`
  justify-content: space-between;
  gap: 40px;

  @media (max-width: 900px) {
    flex-direction: column;
    gap: 50px;
  }
`;

const StepItem = styled(Box)`
  flex: 1;
  max-width: 380px;
  text-align: left;
  position: relative;

  &:not(:last-child) {
    border-right: 1px solid #e0e0e0;
    padding-right: 20px;
  }

  @media (max-width: 900px) {
    max-width: 100%;
    &:not(:last-child) {
      border-right: none;
      padding-right: 0px;
    }
  }
`;

const NumberCircle = styled(Flex)`
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background-color: #ff4f00;
  box-shadow: 0 0 0 12px rgba(255, 79, 0, 0.25);
  color: white;
  font-size: 28px;
  justify-content: center;
  align-items: center;
  margin-bottom: 32px;

  @media (max-width: 768px) {
    width: 56px;
    height: 56px;
    font-size: 22px;
    box-shadow: 0 0 0 8px rgba(255, 79, 0, 0.25);
  }
`;

const StepTitle = styled.h3`
  font-size: 32px;
  font-weight: 400;
  margin-bottom: 14px;
  color: #100f0e;

  @media (max-width: 768px) {
    font-size: 24px;
  }
`;

const StepText = styled(Text)`
  font-size: 16px;
  line-height: 1.6;
  color: #252422;

  @media (max-width: 768px) {
    font-size: 15px;
  }
`;

const stepsData = [
  {
    number: '01',
    title: 'Find Your Medication',
    description: 'View your repeat medicines and order them directly from your pharmacy.',
  },
  {
    number: '02',
    title: 'Track your order',
    description: 'We’ll keep you updated as your request moves from your GP surgery to your pharmacy.',
  },
  {
    number: '03',
    title: 'Collect your medication',
    description: 'You’ll be notified when your prescription is ready for collection or delivery.',
  },
];

const HowItWorks = () => {
  return (
    <HowItWorksSection>
      <SectionBadge>
        <div
          style={{
            height: '6px',
            width: '6px',
            backgroundColor: '#ff5c35',
            clipPath: 'polygon(0 100%, 100% 100%, 100% 0)',
          }}
        />
        <BadgeText>How it works</BadgeText>
      </SectionBadge>

      <MainHeading>
        From ordering your repeat medicines to collecting them from your pharmacy, we make every step straightforward.
      </MainHeading>

      <StepsGrid>
        {stepsData.map((step) => (
          <StepItem key={step.number}>
            <NumberCircle>{step.number}</NumberCircle>
            <StepTitle>{step.title}</StepTitle>
            <StepText>{step.description}</StepText>
          </StepItem>
        ))}
      </StepsGrid>
    </HowItWorksSection>
  );
};

export default HowItWorks;
